import { render, staticRenderFns } from "./RepxRepairStages.vue?vue&type=template&id=ad9c5772"
import script from "./RepxRepairStages.vue?vue&type=script&lang=js"
export * from "./RepxRepairStages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad9c5772')) {
      api.createRecord('ad9c5772', component.options)
    } else {
      api.reload('ad9c5772', component.options)
    }
    module.hot.accept("./RepxRepairStages.vue?vue&type=template&id=ad9c5772", function () {
      api.rerender('ad9c5772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/repx/RepxRepairStages.vue"
export default component.exports